export default __webpack_public_path__ + "static/media/drawing1.ed297ffd.webp";